import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useQueryState(key, initialValue = null) {
  const queryClient = useQueryClient();

  const setValue = useMutation({
    mutationFn: async (val) => val,
    onSuccess: (val) => {
      if (val !== null && val !== undefined) {
        queryClient.setQueryData([key], val);
      } else {
        queryClient.removeQueries({ queryKey: [key] });
      }
    },
  });

  const { data: value } = useQuery({
    queryKey: [key],
    queryFn: async () => {
      const cached = queryClient.getQueryData([key]);
      if (cached !== undefined) return cached;
      return initialValue ?? null;
    },
    // Keep it around and avoid refetches
    // staleTime: Infinity,
    // gcTime: Infinity,
    // retry: false,
    // refetchOnMount: false,
    // refetchOnWindowFocus: false,
    // refetchOnReconnect: false,
    // enabled: true,
  });

  const clearValue = () => {
    queryClient.removeQueries({ queryKey: [key] });
  };
  
  return { value, setValue, clearValue};
}


